"use strict";

/*
*
*   CLIENT PROFILE BANNER UPLOADER
*
*/

// Class definition
var KTUploaderBannerClientProfile = function () {
	// Elements
	var logo;

	var _initForm = function() {
    	logo = new KTImageInput('kt_client_profile_banner');
	}

	return {
		// public functions
		init: function() {
			_initForm();
		}
	};
}();

jQuery(document).ready(function() {
	KTUploaderBannerClientProfile.init();
});
